import { GetShopCategoriesQuery } from './getShopCategories';

type GetShopCategoriesQueryWrapper = {
  data: GetShopCategoriesQuery;
  extensions: {
    cost: {
      'shop-content-service': {
        maxQueryCost: number;
        requestedQueryCost: number;
        actualQueryCost: number;
      };
    };
  };
};

export default {
  data: {
    shopContent: {
      productDetailsPage: {
        categorySetModule: {
          categorySet: {
            id: 'departments',
            cardLayout: 'ICON',
            cards: [
              {
                id: 'ICON-c3320eae-a0ae-49bd-95d9-7947deabd7a3',
                category: {
                  id: 'c3320eae-a0ae-49bd-95d9-7947deabd7a3',
                },
                destinationPath:
                  '/shop/categories/c3320eae-a0ae-49bd-95d9-7947deabd7a3',
                title: 'New Arrivals',
                image: {
                  altText: 'New Arrivals',
                  baseUrl:
                    'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                  mediaPath: '/v1638214528/shop-admin/pbpawzwqut0xcvspelao.png',
                  __typename: 'ShopCategoryImage',
                },
                __typename: 'ShopCategoryCard',
              },
              {
                id: 'ICON-3a7b4540-56ac-48e7-bc05-92e0c3f8acab',
                category: {
                  id: 'c3320eae-a0ae-49bd-95d9-7947deabd7a3',
                },
                destinationPath:
                  '/shop/categories/3a7b4540-56ac-48e7-bc05-92e0c3f8acab',
                title: 'Maternity clothing',
                image: {
                  altText:
                    "Stitch Fix women's purple bow sleeved maternity top.",
                  baseUrl:
                    'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                  mediaPath: '/v1648179159/shop-admin/oxb79mlijdkwrvwoedf4.png',
                  __typename: 'ShopCategoryImage',
                },
                __typename: 'ShopCategoryCard',
              },
              {
                id: 'ICON-34a5d0d5-047c-4139-9b38-5e640b1f7e8e',
                category: {
                  id: 'c3320eae-a0ae-49bd-95d9-7947deabd7a3',
                },
                destinationPath:
                  '/shop/categories/34a5d0d5-047c-4139-9b38-5e640b1f7e8e',
                title: 'Petite clothing',
                image: {
                  altText:
                    "Stitch Fix women's blue chambray short sleeved petite dress with ruffled hem",
                  baseUrl:
                    'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                  mediaPath: '/v1648179303/shop-admin/i2qad70tiicawj1kc99q.png',
                  __typename: 'ShopCategoryImage',
                },
                __typename: 'ShopCategoryCard',
              },
              {
                id: 'ICON-7ce45287-da40-4288-9dc3-3b13e85211f2',
                category: {
                  id: 'c3320eae-a0ae-49bd-95d9-7947deabd7a3',
                },
                destinationPath:
                  '/shop/categories/7ce45287-da40-4288-9dc3-3b13e85211f2',
                title: 'Casual tops',
                image: {
                  altText:
                    "Stitch Fix Women's clothing including a light grey long sleeved top",
                  baseUrl:
                    'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                  mediaPath: '/v1644527565/shop-admin/zolk8nhutveq8smdomub.png',
                  __typename: 'ShopCategoryImage',
                },
                __typename: 'ShopCategoryCard',
              },
              {
                id: 'ICON-44d6fa60-9b03-4bdb-8187-78524868331d',
                category: {
                  id: 'c3320eae-a0ae-49bd-95d9-7947deabd7a3',
                },
                destinationPath:
                  '/shop/categories/44d6fa60-9b03-4bdb-8187-78524868331d',
                title: 'Jeans',
                image: {
                  altText:
                    "Stitch Fix women's light wash jeans with button closure.",
                  baseUrl:
                    'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                  mediaPath: '/v1644528131/shop-admin/oemnftfiyxx8r19zjzhx.png',
                  __typename: 'ShopCategoryImage',
                },
                __typename: 'ShopCategoryCard',
              },
              {
                id: 'ICON-927b1068-a308-45b1-af68-865a34d753d7',
                category: {
                  id: 'c3320eae-a0ae-49bd-95d9-7947deabd7a3',
                },
                destinationPath:
                  '/shop/categories/927b1068-a308-45b1-af68-865a34d753d7',
                title: 'Dresses & jumpsuits',
                image: {
                  altText:
                    "Stitch Fix women's pink utility jumpsuit with short sleeves",
                  baseUrl:
                    'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                  mediaPath: '/v1644527968/shop-admin/cnvqqfsqdasbeqox8dzc.png',
                  __typename: 'ShopCategoryImage',
                },
                __typename: 'ShopCategoryCard',
              },
              {
                id: 'ICON-cc547f54-e933-41ef-aaea-50272007b61b',
                category: {
                  id: 'c3320eae-a0ae-49bd-95d9-7947deabd7a3',
                },
                destinationPath:
                  '/shop/categories/cc547f54-e933-41ef-aaea-50272007b61b',
                title: 'Pants',
                image: {
                  altText: "Stitch Fix women's yellow utility pants",
                  baseUrl:
                    'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                  mediaPath: '/v1644528213/shop-admin/zeyyjmtkoqv2u1vibqlf.png',
                  __typename: 'ShopCategoryImage',
                },
                __typename: 'ShopCategoryCard',
              },
              {
                id: 'ICON-94b8cc54-e8cf-4747-ac37-36213c719af3',
                category: {
                  id: 'c3320eae-a0ae-49bd-95d9-7947deabd7a3',
                },
                destinationPath:
                  '/shop/categories/94b8cc54-e8cf-4747-ac37-36213c719af3',
                title: 'Blouses',
                image: {
                  altText:
                    "Stitch Fix women's pink floral blouse with a tie back detail.",
                  baseUrl:
                    'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                  mediaPath: '/v1635812542/shop-admin/cbd2f0vahvewasrbx5gs.jpg',
                  __typename: 'ShopCategoryImage',
                },
                __typename: 'ShopCategoryCard',
              },
              {
                id: 'ICON-9e98503c-60a7-4f57-8bd7-6484c3cbcdec',
                category: {
                  id: 'c3320eae-a0ae-49bd-95d9-7947deabd7a3',
                },
                destinationPath:
                  '/shop/categories/9e98503c-60a7-4f57-8bd7-6484c3cbcdec',
                title: 'Sweaters & cardigans',
                image: {
                  altText: "Stitch Fix women's multi color stripey sweater",
                  baseUrl:
                    'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                  mediaPath: '/v1644527806/shop-admin/df8ep3skhyjbpfjlbc2r.png',
                  __typename: 'ShopCategoryImage',
                },
                __typename: 'ShopCategoryCard',
              },
            ],
            __typename: 'ShopCategorySet',
          },
          cta: {
            destinationPath: '/shop/categories/departments',
            text: 'Shop more',
            __typename: 'ShopContentCta',
          },
          endCard: {
            cta: {
              destinationPath: '/shop/categories/departments',
              text: 'Shop more',
              __typename: 'ShopContentCta',
            },
            image: {
              altText: '',
              baseUrl:
                'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
              mediaPath:
                '/v1630598918/shop-content-service/Carousel-end-card-shop.png',
              __typename: 'ShopContentImage',
            },
            __typename: 'ShopEndCard',
          },
          title: 'Shop more departments',
          __typename: 'ShopCategorySetModule',
        },
        __typename: 'ShopProductDetailsPage',
      },
      __typename: 'ShopContent',
    },
  },
  extensions: {
    cost: {
      'shop-content-service': {
        maxQueryCost: 5000,
        requestedQueryCost: 29,
        actualQueryCost: 93,
      },
    },
  },
} as GetShopCategoriesQueryWrapper;
